import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Inner from "../../components/Inner";
import Title from "../../components/Title";
import Button from "../../components/Button";
import { Link, useParams } from "react-router-dom";
import { routes } from "../../routes";
import { useCart } from "../../utils/useCart";
import { show as fetchOrder } from "../../api/orderApi";

function PaymentSuccess() {
  const { t } = useTranslation();
  const { cart, removeFromCart } = useCart();
  const { id } = useParams();
  const [orderId, setOrderId] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    cart.forEach(item => removeFromCart(item.id));
  }, []);

  useEffect(() => {
    async function getOrderId() {
      setLoading(true);
      setError("");
      try {
        const response = await fetchOrder(id);
        setOrderId(response.order_id);
      } catch (err) {
        setError(t("Something went wrong. Please try again."));
      } finally {
        setLoading(false);
      }
    }
    if (id) getOrderId();
  }, [id, t]);

  return (
    <>
      <Title>{t("Order Successful")}</Title>
      <Inner>
        <div className="flex flex-col items-center justify-center py-16 gap-8">
          <svg width="80" height="80" viewBox="0 0 24 24" fill="none">
            <circle cx="12" cy="12" r="12" fill="#22c55e" />
            <path
              d="M7 13l3 3 7-7"
              stroke="#fff"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              fill="none"
            />
          </svg>
          <h1 className="text-4xl font-bold text-center">{t("Thank you for your purchase!")}</h1>
          <p className="text-lg text-center max-w-xl">
            {t("Your order has been received and is being processed. You will receive a confirmation email shortly.")}
          </p>
          {loading && <div>{t("Loading...")}</div>}
          {error && <div className="text-red-500">{error}</div>}
          {orderId && (
            <div className="text-lg text-center max-w-xl">
              <div className="mb-2">
                {t("Your order number")}: <span className="font-mono">{orderId}</span>
              </div>
              <div>
                {t("In case you still have questions,")}&nbsp;
                <Link to={routes.contact.index} className="underline font-semibold">
                  {t("contact us")}
                </Link>
              </div>
            </div>
          )}
          <Link to={routes.home}>
            <Button
              type="primary"
              title={t("Back to Home")}
              styles="mt-6 bg-black text-white hover:bg-gray-800 transition"
            />
          </Link>
        </div>
      </Inner>
    </>
  );
}

export default PaymentSuccess;